/*
 * @Author: your name
 * @Date: 2021-04-07 13:57:52
 * @LastEditTime: 2024-01-09 15:03:33
 * @LastEditors: zhangquanming 419654548@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \edc-mobile-web\src\request\axios.js
 */
import axios from 'axios'
import { baseUrl } from './url'
import locals from '@/local'
import { Toast } from 'vant'
import router from '../router'
import * as dictionary from '@/assets/js/dictionary.js'
// http://production.dhcmetis.com/api/
// 创建axios实例
const httpService = axios.create({
	baseURL: baseUrl,
	// 请求超时时间
	timeout: 20000
})
httpService.interceptors.request.use(config => {
	let token = 'wechat'
	if (window.sessionStorage['DHC-IDENTITYTYPE'] != dictionary.identityType[0].value && locals.getUserToken()) {
		token = locals.getUserToken()
	}
	config.headers.token = token
	return config
})
httpService.interceptors.response.use(
	response => {
		const res = response.data
		if (res.code === 205) { // token 过期
			const networkFlag = locals.getNetworkFlag()
			if (!networkFlag)Toast.fail('登录过期，请重新登录！')
			locals.setNetworkFlag(true)
			locals.delUserToken('token')
			router.replace({
				path: '/login',
				query: { redirect: router.currentRoute.fullPath }
			})
			return Promise.reject('error')
		} else {
			locals.setNetworkFlag(false)
			return Promise.resolve(response.data)
		}
	},
	error => {
		if (error && error.response) {
			switch (error.response.status) {
			case 400:
				error.message = '错误请求'
				Toast.fail(error.message)
				break
			case 403:
				error.message = '拒绝访问'
				Toast.fail(error.message)
				break
			case 404:
				error.message = '请求错误,未找到该资源'
				Toast.fail(error.message)
				break
			case 405:
				error.message = '请求方法未允许'
				Toast.fail(error.message)
				break
			case 408:
				error.message = '请求超时'
				Toast.fail(error.message)
				break
			case 500:
				error.message = '服务器端出错'
				Toast.fail(error.message)
				break
			case 501:
				error.message = '网络未实现'
				Toast.fail(error.message)
				break
			case 502:
				error.message = '网络错误'
				Toast.fail(error.message)
				break
			case 503:
				error.message = '服务不可用'
				Toast.fail(error.message)
				break
			case 504:
				error.message = '网络超时'
				Toast.fail(error.message)
				break
			case 505:
				error.message = 'http版本不支持该请求'
				Toast.fail(error.message)
				break
			default:
				error.message = `连接错误${error.response.status}`
			}
		} else {
			error.message = '连接到服务器失败'
			Toast.fail(error.message)
		}
		// const networkFlag = locals.getNetworkFlag()
		// if (networkFlag) {
		// 	locals.setNetworkFlag(false)
		// }
		return Promise.reject(error)
	}
)
/**
 * get方法，对应get请求
 * @param {String} url 请求的url地址
 * @param {Object} params 请求时携带的参数
 */
export function get(url, params) {
	return new Promise((resolve) => {
		httpService({
			url: url,
			method: 'get',
			params: params
		}).then(response => {
			resolve(response)
		}).catch(error => {
			resolve(error)
		})
	})
}
/**
 * post方法，对应post请求
 * @param {String} url  请求的url地址
 * @param {Object} params 请求时携带的参数  json
 */
export function post(url, params = {}) {
	// const researchCode = locals.getResearchCode()
	return new Promise((resolve) => {
		httpService({
			url: url,
			method: 'post',
			data: {
				...params
			}
		}).then(response => {
			resolve(response)
		}).catch(error => {
			resolve(error)
		})
	})
}
/**
 * getUrl方法
 * @param {String} url  请求的url地址
 */
export function getUrl(url) {
	return `${baseUrl}${url}`
}
/**
 * uploadServer方法
 * @param {String} url  请求的url地址
 * @param {String} file  文件内容
 */
export function uploadServer(url, file) {
	return new Promise((resolve) => {
		const researchCode = locals.getResearchCode()
		const fileForm = new FormData()
		fileForm.append('file', file)
		if (researchCode) fileForm.append('researchCode', researchCode)
		httpService({
			url: url,
			method: 'post',
			headers: {
				'Content-Type': 'multipart/form-data'
			},
			data: fileForm
		}).then(response => {
			resolve(response)
		}).catch(error => {
			resolve(error)
		})
	})
}
export default httpService